import React, { useEffect, useMemo, useRef, useState } from "react";
import Dropdown from "./Dropdown";
import "./ScheduleWrapper.css";
import { AdvancedRealTimeChart } from "react-ts-tradingview-widgets-fixed";
import ChartWS from "./ChartWS";
import axios from "axios";
import { useTranslation } from "react-i18next";
import BuyOrder from "./orders/BuyOrder";
import useIsMobile from "./useIsMobile";

const ScheduleWrapper = ({
  symbolMarket,
  buyOrderComponent,
  coinFrom,
  coinTo,
}) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  // Глубина стакана: на мобильном 7 строк (как в старой мобильной версии), на десктопе 12
  const depthLimit = isMobile ? 7 : 12;
  const [orders, setOrders] = useState([]);
  const [ordersAsks, setOrdersAsks] = useState([]);
  const [withChart, setWithChart] = useState(null)
  const chartBlockRef = useRef(null);

  function number_format(number, decimals, dec_point, thousands_sep) {
    number = (number + "").replace(/[^0-9+\-Ee.]/g, "");
    var n = !isFinite(+number) ? 0 : +number,
      prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
      sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
      dec = typeof dec_point === "undefined" ? "." : dec_point,
      s = "",
      toFixedFix = function (n, prec) {
        var k = Math.pow(10, prec);
        return "" + Math.round(n * k) / k;
      };
    s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || "").length < prec) {
      s[1] = s[1] || "";
      s[1] += new Array(prec - s[1].length + 1).join("0");
    }
    return s.join(dec);
  }

  // настройки нового ордера
  const [price, setPrice] = useState("");
  const [priceSell, setPriceSell] = useState("");
  const [price2, setPrice2] = useState("");
  const [priceSell2, setPriceSell2] = useState("");
  const [isLoadedOrders, setIsLoadedOrders] = useState(false);
  const [AVG, setAVG] = useState("");

  const [menuSelection, setMenuSelection] = useState(1);
  const requireAVGdata = () =>
    axios
      .get(`https://api-ru.fynex.cc/charts/api/24hr/${symbolMarket}`)
      .then((res) => {
        setAVG(res.data.lastPrice);
      });
  const requireOrders = () =>
    axios
      .get(
        `https://api-ru.fynex.cc/charts/api/depth/${symbolMarket}?limit=${depthLimit}`
      )
      .then((order) => {
        const asks = order.data.asks || [];
        const bids = order.data.bids || [];
        setOrdersAsks(asks);
        setOrders(bids);
        setIsLoadedOrders(true);
        if (asks[0]) {
          setPrice(asks[0][0]);
          setPrice2(asks[0][0]);
        }
        if (bids[0]) {
          setPriceSell(bids[0][0]);
          setPriceSell2(bids[0][0]);
        }
      });

  const averagePrice = 67325; // Пример средней цены

  const getColorClass = (value) => (value < 0 ? "minus" : "plus");

  useEffect(() => {
    requireOrders();
    requireAVGdata();
    const intervalId = setInterval(() => {
      requireOrders();
      requireAVGdata();
    }, 2500);
    return () => clearInterval(intervalId);
  }, [symbolMarket, depthLimit]);

  const generateBackgroundTable = (order) => {
    console.log(orders);
  };
  const [linearGradient, setLinearGradient] = useState([
    "100",
    "20",
    "30",
    "40",
    "50",
    "60",
    "70",
  ]);
  const [linearGradient2, setLinearGradient2] = useState([
    "100",
    "20",
    "30",
    "40",
    "50",
    "60",
    "70",
  ]);

  function convectator(value, in_min, in_max, out_min, out_max) {
    return (
      ((value - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
    );
  }

  const sumUSDT = (priceUSDT, countBTC) => {
    let sum = String(Number(priceUSDT) * Number(countBTC));
    sum = number_format(sum, 2);
    // if(sum.length > 5) sum.length = 5
    // console.log(sum);
    return sum;
  };
  // console.log("====================================");
  // console.log(orders);
  // console.log("====================================");
  useEffect(() => {
    const tmp = [...linearGradient];
    const tmp2 = [...linearGradient2];

    const ordersCountList = orders.map((item) => Number(item[1]));
    const ordersCountList2 = ordersAsks.map((item) => Number(item[1]));

    ordersCountList.forEach((item, idx) => {
      const min = Math.min(...ordersCountList);
      const max = Math.max(...ordersCountList);
      tmp[idx] = max === min ? 40 : convectator(item, min, max, 0, 100);
    });
    ordersCountList2.forEach((item, idx) => {
      const min = Math.min(...ordersCountList2);
      const max = Math.max(...ordersCountList2);
      tmp2[idx] = max === min ? 40 : convectator(item, min, max, 0, 100);
    });
    setLinearGradient(tmp);
    setLinearGradient2(tmp2);
  }, [orders, ordersAsks]);

  // let chartContent = useMemo(
  //   () => (
  //     // <AdvancedRealTimeChart
  //     //   timezone="Europe/Moscow"
  //     //   theme="dark"
  //     //   allow_symbol_change="false"
  //     //   interval="5"
  //     //   height={100}
  //     //   hide_top_toolbar={true}
  //     //   hide_side_toolbar={true}
  //     //   symbol={symbolMarket}
  //     //   autosize
  //     // />
  //   ),
  //   []
  // );

  let chartContent = useMemo(
    () => <ChartWS symbol={symbolMarket} withChart={withChart} />,
    [withChart, symbolMarket]
  );

  // Ширина блока графика: замеряем сразу и пересчитываем при ресайзе / повороте
  // экрана / переходе между десктопом и мобильной раскладкой.
  useEffect(() => {
    const el = chartBlockRef.current;
    if (!el) return;
    const measure = () => {
      const w = el.offsetWidth;
      if (w > 0) setWithChart((prev) => (prev === w ? prev : w));
    };
    measure();
    if (typeof ResizeObserver === "undefined") {
      window.addEventListener("resize", measure);
      return () => window.removeEventListener("resize", measure);
    }
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <div className="schedule-wrapper">
      {/* Вкладки «График / Стакан» — видны только в мобильной версии (см. ScheduleWrapper.css) */}
      <div className="schedule-menu">
        <span onClick={() => setMenuSelection(1)}>
          <h4 className={menuSelection == 1 ? "span-active" : ""}>{t("schedule.chart")}</h4>
          <div className={menuSelection == 1 ? "line line-activ" : "line"}></div>
        </span>
        <span onClick={() => setMenuSelection(2)}>
          <h4 className={menuSelection == 2 ? "span-active" : ""}>{t("schedule.order_book")}</h4>
          <div className={menuSelection == 2 ? "line line-activ" : "line"}></div>
        </span>
      </div>

      <div className="schedule">
        <div
          className={
            menuSelection == 2
              ? "wrapper-menu wrapper-menu-active"
              : "wrapper-menu"
          }
        >
          <div className="schedule-block" ref={chartBlockRef}>{chartContent}</div>
          {/* <div className="schedule-block">{chartContent}</div> */}
          <div className="OrderGlass">
            <table className="og-side og-bids">
              <thead>
                <tr>
                  <th>
                    {t("schedule.price_usdt")} ({coinFrom})
                  </th>
                  <th>
                    {t("schedule.quantity_btc")} ({coinTo})
                  </th>
                  <th>
                    {t("schedule.sum_usdt")} ({coinFrom})
                  </th>
                </tr>
              </thead>
              <tbody>
                {[...orders].reverse().map((order, index) => {
                  const gradIndex = orders.length - 1 - index;
                  const depth = linearGradient[gradIndex] ?? 0;
                  return (
                  <tr
                    key={`bid-${order[0]}-${index}`}
                    style={{
                      background: `linear-gradient(-90deg, rgba(32, 172, 149, 0.2) ${depth}%, rgba(255,255,255,0) ${depth}%)`,
                    }}
                  >
                    <td className="price plus">
                      {order[0].toLocaleString()}
                    </td>
                    <td>{order[1].toLocaleString()}</td>
                    <td>{sumUSDT(order[0], order[1])}</td>
                  </tr>
                  );
                })}
              </tbody>
            </table>

            <div className="average-price">
              <h2 className={getColorClass(averagePrice)}>
                {AVG.toLocaleString()}
              </h2>
            </div>

            <table className="og-side og-asks">
              <tbody>
                {ordersAsks.map((order, index) => {
                  const depth = linearGradient2[index] ?? 0;
                  return (
                  <tr
                    key={`ask-${order[0]}-${index}`}
                    style={{
                      background: `linear-gradient(-90deg, rgba(226, 70, 74, 0.2) ${depth}%, rgba(255,255,255,0) ${depth}%)`,
                    }}
                  >
                    <td className="price minus">
                      {order[0].toLocaleString()}
                    </td>
                    <td>{order[1].toLocaleString()}</td>
                    <td>{sumUSDT(order[0], order[1])}</td>
                  </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {/* Десктоп: панель ордера — третья колонка грида */}
          {!isMobile && buyOrderComponent}
        </div>
      </div>

      {/* Мобильная: слайдер (график / стакан) занимает 200% ширины, поэтому
          панель ордера выводим под ним, а не внутри слайдера */}
      {isMobile && buyOrderComponent}
    </div>
  );
};

export default ScheduleWrapper;
